<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import DeviceInfo from '@/modules/util/deviceInfo'
  export default {
    computed: {
      ...mapGetters([
        'RssFeedInfo',
        'RssFeedData',
        'MainMenuLayout',
        'resource',
        'DesignSettings'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      RssFeedList() {
        return this.RssFeedData ? this.RssFeedData : []
      }
    },
    created() {
      this.initRssFeedModule(this.SubscriptionModuleId)
    },
    watch: {
      RssFeedInfo: function(value, oldvalue) {
        if(value.RSSFeedURL != oldvalue.RSSFeedURL && Helper.IsDevSim()) {
          this.getRssFeedUrlData(value.RSSFeedURL)
        }
      }
    },
    methods: {
      ...mapActions([
        'loadLocalRssFeedData',
        'loadRssFeedData',
        'getRssFeedUrlData'
      ]),
      async initRssFeedModule(SubscriptionModuleId) {
        this.$showLoader()
        this.loadLocalRssFeedData(SubscriptionModuleId)
        this.loadRssFeedData(SubscriptionModuleId).then(async () => {       
          if(Helper.IsValid(this.RssFeedInfo.RSSFeedURL)) {
            await this.getRssFeedUrlData(this.RssFeedInfo.RSSFeedURL)
          }
          this.$hideLoader()
          this.$RegisterPageView({
            'SubscriptionModule_Id': SubscriptionModuleId,
            'ContentGUID': this.RssFeedInfo.Id,
            'ViewType': 1
          })
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      isNullOrEmpty: function(value) {
        return Helper.IsNullOrEmpty(value)
      },
      rssFeedDetails(feedid) {
        return `/rss-detail-view/${this.SubscriptionModuleId}/${feedid}`
      },
      formattedDate: function(value) {
        if(!Helper.IsNullOrEmpty(value)) {
          return `${Helper.FormattedDateDDMMMMYYHHMM(value, this.resource.strUhr)}`
        } else {
          return null
        }      
      },
      getImageFromFeed(text) {
        let div = document.createElement('div')
        div.innerHTML = text
        let firstImage = div.getElementsByTagName('img')[0]
        let rawImgSrc = firstImage ? firstImage.getAttribute("src") : ""
        return rawImgSrc
      },
      showImage(text) {
        let rawImgSrc = this.getImageFromFeed(text)
        if (rawImgSrc.length > 0) {
          return true
        } else {
          return false
        }
      },
      getFeedImage(text) {
        let rawImgSrc = this.getImageFromFeed(text)
        if (rawImgSrc.length > 0) {
          return {
            'background-image': `url(${rawImgSrc})`
          }
         } else {
          return {}
         }   
      },
      handleReadMoreClick(value) {
        if (Helper.IsUserActionAllow()) {
            Helper.showURL(value, this.DesignSettings.AppThemeColor, this.DesignSettings.AppThemeFontColor)
        } else {
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      },
      isShowReadMoreBtn(value) {
        return !Helper.IsNullOrEmpty(value)
      },
      replaceContentClass(value) {
        let regex = /class/gi
        value = value.replace(regex, 'data')
        regex = /<a/gi
        value = value.replace(regex, '<div')
        regex = /a>/gi
        value = value.replace(regex, 'div>')
        return value
      }
    }
  }
</script>
<template>
  <f7-page ref="rssFeedPage" :page-content="false" name="rssfeed-view">
    <app-header :header="RssFeedInfo.PageTitle"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <div class="backgroundimg"></div>
    <f7-page-content class="infinite-scroll" v-if="RssFeedInfo">
      <f7-link class="list_display_block" v-if="isNullOrEmpty(RssFeedInfo.RSSFeedUR)" v-for="(Items, index) in RssFeedList" :key="index" @click="handleReadMoreClick(Items.Link)">
        <f7-card>
          <!-- <f7-card-header
            valign="bottom"
            :class="{'cover-background': true, card__headerNoImage : !showImage(Items.Summary.Text) , card__headerImage : showImage(Items.Summary.Text), 'no-image' : !showImage(Items.Summary.Text)}"
            :style="getFeedImage(Items.Summary.Text)">
            <div :class="{card__headerNoImageCaption : !showImage(Items.Summary.Text) , card__headerImageCaption : showImage(Items.Summary.Text) }">
              <div class="card__CaptionText">{{Items.Title.Text}}</div>
            </div>
          </f7-card-header> -->
          <f7-card-header>
            <div class="card__CaptionText">{{Items.Title}}</div>
          </f7-card-header>
          <f7-card-content>
            <!-- <div>{{Items.Title.Text}}</div><br> -->
            <!-- <div v-html="Items.Summary.Text"></div><br> -->
            <p class="post-date" v-if="formattedDate(Items.PubDate)">{{formattedDate(Items.PubDate)}}</p>
            <div class="rss-feed-content" v-html="replaceContentClass(Items.Description)"></div>
          </f7-card-content>
          <f7-card-footer v-if="isShowReadMoreBtn(Items.Link)">
             <a></a><a>{{resource.readMoreBtn}}</a>
          </f7-card-footer>
        </f7-card>
      </f7-link>
    </f7-page-content>
    <!-- <f7-page-content v-else>
      <f7-block strong inset>
        <p>{{resource.norssdata}}</p>
      </f7-block>
    </f7-page-content> -->
  </f7-page>
</template>
<style scoped>
  .post-date {
    font-size: 12px;
    color: #7d7972;
  }
  .rss-feed-content >>> img {
    max-width: 100%;
    height: auto;
  }
  .ios .card-content-padding {
    padding-bottom: 0px!important;
  }
  .rss-feed-content >>> iframe {
    width: 100% !important;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/rssFeed/RssFeed.vue